import moment from 'moment';
import _ from 'lodash';

const getTeacherAvailability = state => {
  const availability = [];

  if (state.teacher.availability) {
    const groupedByDay = {};
    _.each(state.teacher.availability.schedules, s => {
      if (!groupedByDay[s.weekday]) groupedByDay[s.weekday] = [];
      groupedByDay[s.weekday].push(s);
    });

    const startOfWeek = moment().startOf('week');
    const endOfWeek = moment().endOf('week');

    let day = startOfWeek;
    while (day < endOfWeek) {
      const dayText = day.format('ddd').toLowerCase();
      const weekDay = groupedByDay[dayText];
      if (weekDay) {
        for (const schedule of weekDay) {
          const startTime = moment(schedule.displayStartTime, 'h:mm A');
          const endTime = schedule.displayEndTime.includes('next') ?
            moment('11:59 PM', 'h:mm A') :
            moment(schedule.displayEndTime, 'h:mm A');

          availability.push({
            start: new Date(
              day.clone().set({ hour: startTime.get('hour'), minute: startTime.get('minute') })
            ),
            end: new Date(
              day.clone().set({ hour: endTime.get('hour'), minute: endTime.get('minute') })
            ),
            resource: dayText
          });
        }
      }

      day = day.clone().add(1, 'd');
    }
  }

  return availability;
};

export default getTeacherAvailability;



// WEBPACK FOOTER //
// ./src/selectors/Teacher/TeacherAvailabilitySelector.js